import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { logout } from "../../features/auth";
import { getItemWebStorage } from "../../features/webStorageSaver";

type Path = {
    pathId?: number,
    pathName?: string,
    roadId?: number,
    roadName?: string,
    raionId?: string
}

type PathsInfo = {
    selectedPath?: Path,
    pathsList?: any,
    roadsList?: any,
    roadRaionSegments?: any,
    idsOfPathsWithGeometry?: any,
    pathsSearchValue?: any,
    pathsListIsGroupedByRaions?: boolean
}

function getInitialState() {
    const { selectedPath, pathsList, roadsList, idsOfPathsWithGeometry, roadRaionSegments, pathsListIsGroupedByRaions } = getItemWebStorage('pathsInfo') ?? {}
    const initialState: PathsInfo = {
        selectedPath,
        pathsList,
        roadsList,
        roadRaionSegments,
        idsOfPathsWithGeometry,
        pathsSearchValue: null,
        pathsListIsGroupedByRaions
    }
    return initialState
}

export const pathsInfoSlice = createSlice({
    name: 'pathsInfo',
    initialState: getInitialState(),
    reducers: {
        setSelectedPath(state, action: PayloadAction<any>) {
            state.selectedPath = action.payload
        },
        setPathsList(state, action: PayloadAction<any>) {
            state.pathsList = action.payload
        },
        setRoadsList(state, action: PayloadAction<any>) {
            state.roadsList = action.payload
        },
        setRoadRaionSegments(state, action: PayloadAction<any>) {
            state.roadRaionSegments = action.payload
        },
        setIdsOfPathsWithGeometry(state, action: PayloadAction<any>) {
            state.idsOfPathsWithGeometry = action.payload
        },
        setPathsSearchValue(state, action: PayloadAction<any>) {
            state.pathsSearchValue = action.payload
        },
        setPathsListIsGroupedByRaions(state, action: PayloadAction<any>) {
            state.pathsListIsGroupedByRaions = action.payload
        },
    },
    extraReducers: (builder) => {
        builder.addCase(logout, () => {
            return getInitialState()
        })
    },
})

export const {
    setSelectedPath,
    setPathsList,
    setRoadsList,
    setRoadRaionSegments,
    setIdsOfPathsWithGeometry,
    setPathsSearchValue,
    setPathsListIsGroupedByRaions
} = pathsInfoSlice.actions
export const pathsInfoReducer = pathsInfoSlice.reducer;
